const Cursors = {
  DEFAULT: 'default',
  GRAB: 'grab',
  GRABBING: 'grabbing',
  NONE: 'none',
  RESIZE_EW: 'ew-resize',
  RESIZE_NS: 'ns-resize',
  RESIZE_NESW: 'nesw-resize',
  RESIZE_NWSE: 'nwse-resize'
};

export default Cursors;
